module.exports = __webpack_public_path__ + "static/media/vendor-master.cdbce596.jpeg";